export default __webpack_public_path__ + "static/media/Group2.d3b41e0d.png";